module.exports = "<div class='container-fluid'>\r\n  <div class='row'>\r\n      <div class='col-sm-2'>\r\n        <main-header></main-header>\r\n      </div>\r\n      <div class='col-sm-10 body-content'>\r\n          <router-outlet></router-outlet>\r\n      </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/layout.component.html
// module id = ../../../../../src/app/layout/layout.component.html
// module chunks = main